//
// # Unique ID
// # Usage, Validation, and Mapping
//

// NPM Imports
import typia from "typia";
import { v4 as uuidv4 } from "uuid";

// Local Imports
import { Validator } from "./validate";

export type Uuid = string & typia.tags.Format<"uuid">;

export const Uuid = {
  new: (): Uuid => uuidv4(),
  eq: (a: Uuid, b: Uuid): boolean => a === b,
  validator: new Validator(typia.createValidate<Uuid>()),
  stringify: (u: Uuid): string => u, // NOTE: we had a call to `typia.json.createStringify<Uuid>()`, but it adds quotes! SAD!
};

export interface HasUuid {
  uuid: Uuid;
}

export class UuidMap<Value extends HasUuid> {
  private inner = new Map<Uuid, Value>(); // The core inner map

  get = (u: Uuid) => this.inner.get(u);
  has = (u: Uuid) => this.inner.has(u);
  hasValue = (v: Value) => this.inner.has(v.uuid);
  delete = (u: Uuid) => this.inner.delete(u);
  insert = (v: Value) => this.inner.set(v.uuid, v);
}
